import TopBar from "../../components/topBar/topBar";
import { useState } from 'react';
import { getCitation } from "../../helpers/citation.helper";
import { getFormAuthors } from "../../helpers/authors.helper";
import { getKeywords } from "../../helpers/keywords.helper";
import { apiClient } from "../../api/apiClient";
import { validateArchiveForm } from "../../validators/archiveValidator";

function ArchiveForm({ setPageState, setSuccess }) {
    const [formValues, setFormValues] = useState({
        title: ' ',
        authors: [],
        archive: '',
        archive_short: '',
        trust: '',
        trust_short: '',
        crate: 0,
        doc_number: 0,
        citation_type: 7,
    })

    const [formErrors, setFormErrors] = useState({});
    const [authors, setAuthors] = useState('');
    const [keywords, setKeywords] = useState('');

    async function handleSubmit() {
        const validation = validateArchiveForm({ ...formValues, authors });

        if (validation == true) {
            // Good stuff
            const finalBody = {
                ...formValues, keywords: getKeywords(keywords)
            }

            const req = await apiClient.post(`/book`, finalBody);
            if (req.status == 200) {
                console.log('Book added');
                setFormValues({
                    title: '',
                    authors: [],
                    archive: '',
                    trust: '',
                    crate: 0,
                    doc_number: 0,
                    citation_type: 7,
                });
                setAuthors('');
                setKeywords('');
                setPageState(0);
                setSuccess(true);
            } else {
                console.log(req);
            }

            console.log(finalBody);
        } else {
            setFormErrors(validation);
        }
    }

    return (
        <div className="min-h-screen">
            <TopBar logo={true} />
            <div className="mx-auto max-w-2xl px-4 sm:px-6 py-10">

                <button
                    type="button"
                    onClick={() => setPageState(0)}
                    className="group mb-8 -ml-1 inline-flex items-center gap-2 text-sm font-light text-mainDark/40 transition-colors duration-200 hover:text-mainDark"
                >
                    <svg className="h-4 w-4 transition-transform duration-200 group-hover:-translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M19 12H5M12 5l-7 7 7 7" />
                    </svg>
                    Go Back
                </button>

                <h1 className="mb-8 text-2xl font-light text-mainDark">Nový archívny článok</h1>

                <div className="flex flex-col gap-5">
                    <div className="w-full">
                        <label htmlFor="archive" className="block text-base font-medium ml-3 text-mainBlue pb-2">Archive</label>
                        <input type="text" className='formInput' onChange={e => setFormValues(values => ({ ...values, archive: e.target.value }))} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.archive}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="trust" className="block text-base font-medium ml-3 text-mainBlue pb-2">Trust</label>
                        <input type="text" className='formInput' onChange={e => setFormValues(values => ({ ...values, trust: e.target.value }))} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.trust}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="crate" className="block text-base font-medium ml-3 text-mainBlue pb-2">Crate</label>
                        <input type="number" className='formInput' onChange={e => setFormValues(values => ({ ...values, crate: e.target.value }))} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.crate}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="doc_number" className="block text-base font-medium ml-3 text-mainBlue pb-2">Document Number</label>
                        <input type="text" className='formInput' onChange={e => setFormValues(values => ({ ...values, doc_number: e.target.value }))} />
                        <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.doc_number}</p>
                    </div>
                    <div className="w-full">
                        <label htmlFor="keywords" className="block text-base font-medium ml-3 text-mainBlue pb-2">Keywords</label>
                        <p className='ml-3 text-sm text-mainDark italic font-thin'>Keyword, Keyword, Keyword, ...</p>
                        <input type="text" className='formInput' onChange={e => setKeywords(e.target.value)} />
                    </div>

                    {validateArchiveForm({ ...formValues, authors }) == true && (
                        <div className="rounded-2xl border border-mainDark/30 bg-mainWhite p-5 shadow-result">
                            <p className="text-[10px] uppercase tracking-widest font-medium text-mainBlue mb-3">Citation preview</p>
                            <p className="text-sm text-mainDark/70 font-light leading-relaxed" dangerouslySetInnerHTML={{ __html: getCitation({ ...formValues }) }} />
                        </div>
                    )}

                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="w-full rounded-3xl bg-primary py-4 text-onPrimary shadow-search transition-all duration-200 hover:brightness-110 hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(0,0,0,0.25)] active:translate-y-0 active:brightness-95"
                    >
                        SUBMIT
                    </button>
                </div>

            </div>
        </div>
    );
}

export default ArchiveForm;
